var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParkingSpa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 20,
    height: 20,
    rx: 1,
    fill: "#7FA9AE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10L4 6V14L0 10Z",
    fill: "#7FA9AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9498 11.6138C12.9498 12.9265 12.9498 14.2238 12.9498 15.552C12.2008 15.552 11.4903 15.552 10.749 15.552C10.749 11.9612 10.749 8.36279 10.749 4.718C12.5405 4.54812 14.332 4.27785 16.1004 4.7875C17.4594 5.1736 18.3166 6.20063 18.4401 7.50565C18.5946 9.11182 17.9691 10.4246 16.7027 11.0964C15.6139 11.6755 14.4479 11.745 13.251 11.6524C13.1583 11.6369 13.0733 11.6215 12.9498 11.6138ZM12.9421 6.41684C12.9421 7.52109 12.9344 8.47862 12.9498 9.44387C12.9498 9.52881 13.0733 9.67553 13.1506 9.69098C13.7915 9.82225 14.4247 9.83769 15.0425 9.57515C15.7606 9.26626 16.1313 8.58673 16.0386 7.75275C15.9614 7.0346 15.444 6.50179 14.6564 6.42457C14.1081 6.37051 13.5444 6.41684 12.9421 6.41684Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9417 6.41692C13.544 6.41692 14.1077 6.37059 14.6637 6.42464C15.4513 6.50186 15.961 7.0424 16.0459 7.75283C16.1386 8.57908 15.7679 9.26634 15.0498 9.57522C14.432 9.83777 13.7988 9.82232 13.1579 9.69105C13.0729 9.67561 12.9571 9.52889 12.9571 9.44395C12.9339 8.4787 12.9417 7.51344 12.9417 6.41692Z",
    fill: "#7FA9AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingSpa);
export default __webpack_public_path__ + "static/media/parking-spa.c7c0f0a295c0ba7502223b1a29e2ced2.svg";
export { ForwardRef as ReactComponent };